import { CASE_CARDS_CODES, CaseCardConfigurationStatusEnum, type CaseCardsCodes, type InteractionCardViewType } from '@/common/types/case'
import caseLayoutItemServerData from '@/common/services/serverData/caseLayoutItemServerData'
import { useCaseStore } from '@/agent/stores/caseStore'
import { useCaseLayoutItemServerData } from '@/common/composables/serverData/useCaseLayoutItemServerData'

export async function initCaseCardLayout() {
  const caseStore = useCaseStore()
  const layoutConfig = await caseLayoutItemServerData.fetch()
  // We need to deep clone the layout config to avoid
  // mutating the original object in the store.
  const clonedConfig = JSON.parse(JSON.stringify(layoutConfig))

  for (const column of clonedConfig) {
    caseStore.layoutColumns.set(column.order, column)
  }
}

export function useCaseCardLayout() {
  const caseStore = useCaseStore()
  const { mutateAsync } = useCaseLayoutItemServerData()

  const toggleExpand = async (code: CaseCardsCodes, expand?: boolean) => {
    const cardConfig = caseStore.layoutCards.get(code)
    if (!cardConfig) return

    if (expand === undefined) {
      if (cardConfig.status === CaseCardConfigurationStatusEnum.EXPANDED) {
        cardConfig.status = CaseCardConfigurationStatusEnum.COLLAPSED
      } else {
        cardConfig.status = CaseCardConfigurationStatusEnum.EXPANDED
      }
    } else {
      cardConfig.status = expand ? CaseCardConfigurationStatusEnum.EXPANDED : CaseCardConfigurationStatusEnum.COLLAPSED
    }

    await mutateAsync([...caseStore.layoutColumns.values()])
  }

  const setInteractionViewType = async (viewType: InteractionCardViewType) => {
    const cardConfig = caseStore.layoutCards.get(CASE_CARDS_CODES.CONVERSATION)
    if (!cardConfig) return

    cardConfig.viewType = viewType
    await mutateAsync([...caseStore.layoutColumns.values()])
  }

  return {
    toggleExpand,
    setInteractionViewType,
    init: initCaseCardLayout,
  }
}
